
import { operateLog } from '@/utils/tool'
/**
 * @method: gtInit调用initGeetest进行初始化
 * @param {Object} params 回调函数中使用的参数
 * @param {Object} data   首次请求需要极验验证，接口返回的极验数据
 *  { challenge: "43f76f5fe51fe1b70b5070adf533b9ab"
      check_type: 1
      gt: "cc48bc199c33a924d1a6b6d297d6f7ca"
      is_repeat_checkable: 0
      new_captcha: 1
      success: 1 
  * }
 * @param {boolean} needCheck  是否需要验证，默认为true
 * @param {element id} lang     语言
 * @param { function } callback 极验验证成功后的回调方法
 * 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
 */
export const gtInit = (params, data, needCheck, lang, callback) => {
  gtDestroy()
  window.needCheck = needCheck
  document.getElementById('check_wrap_fpwd').style.display = 'block'
  document.getElementById('text_fpwd').style.display = 'none'
  document.getElementById('wait_fpwd').style.display = 'block'
  initGeetest(
    {
      lang,
      gt: data.gt,
      post: true,
      challenge: data.challenge,
      offline: !data.success,
      new_captcha: data.new_captcha,
      product: 'popup',
      width: '320px',
      https: true
    },
    function (captchaObj) {
      if(__DEV__){
        document.getElementById('check_wrap_fpwd').style.display = 'block'
        document.getElementById('text_fpwd').style.display = 'none'
        document.getElementById('wait_fpwd').style.display = 'block'
      }
      captchaObj.appendTo('#captcha_fpwd')
      captchaObj.onReady(function (e) {
        document.getElementById('wait_fpwd').style.display = 'none'
      })
      captchaObj.onSuccess(function () {
        var result = captchaObj.getValidate()
        result['old_challenge'] = data.challenge
        if (callback) {
          callback(result, params)
        }
      })
      captchaObj.onClose(function () {
        console.log('you close verify')
      })
      captchaObj.onError(function (e) {
        const { error_code } = e
        // 异常情况下极验兼容，result返回 -1
        const resolveCode = ['error_110', 'error_111', 'error_105', 'error_104']
        if (callback && resolveCode.includes(error_code)) {
          callback(-1, params)
        }
        // 异常情况下手动上报fLog
        operateLog('geetestError', JSON.stringify(e))
      })
      window.gt = captchaObj
    }
  )
}

/**
 * @method: 销毁极验实例
 */
export const gtDestroy = (el) => {
  if (el) {
    el.hide()
  }
  if (window.gt) {
    window.gt.destroy()
  }
}
